<template>
    <div class="table-footer">
        <div class="row">
            <div class="col-md-4">
                <span>Show</span>
                <select class="form-control" v-model="showPerPage" @change="showPerPageChanged()">
                    <option>10</option>
                    <option>25</option>
                    <option>50</option>
                    <option>100</option>
                </select>
                <span>Entries</span>
            </div>
            <div class="col-md-4 text-center" >
                <!-- <span v-if="selectedProducts.length > 0">{{selectedProducts.length}} Selected</span>
                <button v-if="selectedProducts.length > 0" class="btn btn-danger" @click="openConfirmDeleteModal">
                    <i class="fas fa-trash"></i>
                    Delete
                </button> -->
                <!--<button class="btn btn-primary go-popover" data-placement="top">
                    To Campaign Group
                </button>-->
                <!-- <div class="go-popover-container" id="toCampaign" style="display:none;">
                    <div class="go-pop-header">
                        <button id="tagsListing" class="tagsListing btn btn-primary" style="width:250px;">New Campaign Group</button>
                    </div>
                    <hr />
                    <div id="campaign-tags" class="go-pop-body">
                        <div class="go-scrollbar" style="height:130px; overflow-y:auto;">
                            <div><span class="go-tags">Pensils</span></div>
                            <div><span class="go-tags">Markers</span></div>
                            <div><span class="go-tags">Trend 2018</span></div>
                            <div><span class="go-tags">Artists</span></div>
                            <div><span class="go-tags">Artists 2018</span></div>
                            <div><span class="go-tags">Markers 2018</span></div>
                        </div>
                        <hr />
                        <div class="mt-2">
                            <input type="text" class="form-control" placeholder="Enter campaign group name" />
                        </div>
                    </div>
                    <div id="campaign-tags-new" class="campaign-new-tags" style="height:197px; overflow-y:auto; display:none;">
                        <div class="go-tags d-block"><span>Christmas presents <span class="go-tags-new">new</span></span></div>
                        <div class="mt-2">
                            <input type="text" class="form-control" placeholder="New campaign group" />
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="col-md-4 text-right">
                <a href="javascript:void(0)" v-if="currentPageNumber != 1" @click="getPreviousPageList()">Previous </a>
				<select
					class="form-control selectpicker"
					style = 'max-width:80px;'
					id="brandFilter"
					v-model="currentPageNumber"
					@change="getNewPageList()"
				>
					<option
						v-for="index in totalNoOfPages"
						:key="index"
						:value="index"
					>{{index}}</option>
				</select>
                <a href="javascript:void(0)" v-if="(showPerPage == productList.length && (currentPageNumber!=totalNoOfPages))" @click="getNextPageList()"> Next</a>
				<div style = "padding-right:0px;padding-top:5px">{{getCount()}}</div>
            </div>
        </div>
        <ProductListDeleteConfirmModal
			@deleteSelectedProducts="deleteSelectedProducts"
			@closeDeleteConfirmModal="closeDeleteConfirmModal"
		></ProductListDeleteConfirmModal>
    </div>
</template>

<script>
import ProductListDeleteConfirmModal from '@/components/product/ProductListDeleteConfirmModal'

export default {
    name:'ProductListGridFooter',
    data() {
        return {
           	totalNoOfPages:1,
        }
    },
    components: {
        ProductListDeleteConfirmModal,
    },
	watch:{
		totalCampaignAndProductCount(){
			this.calculateIndexPerPage()
		}
	},
    computed: {
        	totalCampaignAndProductCount : {
				set(val) {
					return this.$store.state.totalCampaignAndProductCount = val

				},
				get() {
					return this.$store.state.totalCampaignAndProductCount
				}

			},
        selectedProducts: {
            set(val) {
                this.$store.state.product.selectedProducts = val
            },
            get() {
                return this.$store.state.product.selectedProducts
            }
        },
        productList: {
            set(val) {
                this.$store.state.product.productList = val
            },
            get() {
                return this.$store.state.product.productList
            }
        },
        showPerPage: {
            set(val) {
                sessionStorage.setItem('products:showPerPage',val)
            },
            get() {
                if(sessionStorage.getItem('products:showPerPage')){
                    return sessionStorage.getItem('products:showPerPage')
                }
                return this.$store.state.showPerPage
            }
        },
        currentPageNumber: {
            set(val) {
                this.$store.state.currentPageNumber = val
            },
            get() {
                return this.$store.state.currentPageNumber
            }
        }
    },
    mounted(){
         this.calculateIndexPerPage()
    },
    methods: {
        	calculateIndexPerPage(){
               this.totalNoOfPages=Math.ceil(this.totalCampaignAndProductCount/this.showPerPage)
			},
        openConfirmDeleteModal() {
            $('#confirmDeleteProduct').modal('show')
        },
        deleteSelectedProducts() {
            let vm = this
            let productIds = this.selectedProducts.map((element) => {
                return element.asin
            })
        //    productIds = productIds.join(',')
            this.$store.dispatch('product/deleteMultipleProducts', { data: { productIds: productIds, isSeller: this.$store.state.isSeller }, callback:() => {
                vm.selectedProducts = []
                vm.$store.dispatch('product/getAllProducts')
                $('#confirmDeleteProduct').modal('hide')
            }})
        },
		closeDeleteConfirmModal(){

		},
        getPreviousPageList() {
            if (this.currentPageNumber <= 1) {
                return
            }
            else {
                this.currentPageNumber -= 1
                this.$store.dispatch('product/getAllProducts');
            }
        },
        getNextPageList() {
            this.currentPageNumber += 1
            this.$store.dispatch('product/getAllProducts');
        },
		getNewPageList(){
			this.$store.dispatch('product/getAllProducts');
		},
		getCount(){
			let pageCount = this.showPerPage * (this.currentPageNumber - 1);
			let extendedcount = parseInt(pageCount)+ parseInt(this.productList.length);
            //return	pageCount+1 + ' to ' + extendedcount;
            return	'Showing ' + (pageCount+1) + ' to ' + extendedcount + ' results of ' + this.totalCampaignAndProductCount;
		},
        showPerPageChanged() {
			this.currentPageNumber = 1;
            this.$store.dispatch('product/getAllProducts');
        }
    }
}
</script>

<style lang="scss">

</style>
